import React from 'react';
import Eye from '../icons/Eye';

interface ConnectedUsersIndicatorProps {
  userCount: number;
  className?: string;
}

const ConnectedUsersIndicator: React.FC<ConnectedUsersIndicatorProps> = ({
  userCount,
  className = "",
}) => {
  // Masquer le compteur s'il y a 1 seul utilisateur ou moins
  if (userCount <= 1) return null;

  return (
    <div className={`flex items-center ${className}`}>
      <div
        className="bg-mcdm-primary-200 dark:bg-mcdm-secondary-400 px-3 py-1 rounded-full text-sm font-medium transition-colors flex items-center gap-2"
        style={{ transform: 'translateY(-1px)' }}
        title={`${userCount} utilisateur${userCount > 1 ? 's' : ''} connecté${userCount > 1 ? 's' : ''} sur ce dossier`}
      >
        <Eye width="16px" height="16px" className="text-mcdm-third-400 dark:text-mcdm-primary-100" />
        <span className="text-mcdm-third-400 dark:text-mcdm-primary-100">{userCount}</span>
      </div>
    </div>
  );
};

export default ConnectedUsersIndicator;
